const normalize = (value) => String(value || "").trim().toLowerCase()

const mountPlansIndexSearch = () => {
  document.querySelectorAll("[data-plans-index-search]").forEach((container) => {
    if (container.dataset.searchMounted === "true") return
    container.dataset.searchMounted = "true"

    const input = container.querySelector("[data-plans-index-search-input]")
    const emptyState = container.querySelector("[data-plans-index-search-empty]")
    const buildingSections = Array.from(container.querySelectorAll("[data-building-section]"))
    const standaloneSection = container.querySelector("[data-standalone-section]")
    const standalonePlans = Array.from(container.querySelectorAll("[data-standalone-plan]"))

    if (!input) return

    const filter = () => {
      const query = normalize(input.value)
      let anyVisible = false

      buildingSections.forEach((section) => {
        const buildingName = normalize(section.dataset.buildingName)
        const buildingMatches = query.length === 0 || buildingName.includes(query)
        const plans = Array.from(section.querySelectorAll("[data-building-plan]"))
        let matchingPlanCount = 0

        plans.forEach((plan) => {
          const planName = normalize(plan.dataset.planName)
          const planMatches = query.length === 0 || buildingMatches || planName.includes(query)
          plan.hidden = !planMatches
          if (planMatches) matchingPlanCount += 1
        })

        const showSection = query.length === 0 || buildingMatches || matchingPlanCount > 0
        section.hidden = !showSection
        if (showSection) anyVisible = true
      })

      if (standaloneSection) {
        let visibleStandaloneCount = 0

        standalonePlans.forEach((plan) => {
          const planName = normalize(plan.dataset.planName)
          const planMatches = query.length === 0 || planName.includes(query)
          plan.hidden = !planMatches
          if (planMatches) visibleStandaloneCount += 1
        })

        const showStandaloneSection = standalonePlans.length > 0 && (query.length === 0 || visibleStandaloneCount > 0)
        standaloneSection.hidden = !showStandaloneSection
        if (showStandaloneSection) anyVisible = true
      }

      if (emptyState) emptyState.hidden = anyVisible
    }

    input.addEventListener("input", filter)
    filter()
  })
}

export { mountPlansIndexSearch }
